/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取文章详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.DocumentsArticleDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/documentArticle/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
